<template>
    <div class="pagination">
        <div :class='{"page": true, hide: isMobile}'>
            <p>共 {{pageObj.total}} 条 
                <span v-bind:class='{btn:true, "not-clickable":pageObj.curPage === 1}' @click='preClick'>&lt;</span>

                <span v-bind:class='{btn:true, cur:pageObj.curPage === 1}' @click='pageClick(1)'>1</span>
                <span v-bind:class='{hide: pageObj.curPage < 5}'>...</span>

                <a v-for='index in pages-1' v-bind:key='index' @click="pageClick(index)">
                    <span 
                        v-show='index !== 1 
                            && ((pageObj.curPage !== 1 && pageObj.curPage !== pages && index > pageObj.curPage -3 && index < pageObj.curPage + 3)
                                || ((pageObj.curPage === 1 || pageObj.curPage === pages) && index > pageObj.curPage -4 && index < pageObj.curPage + 4))' 
                        v-bind:class='{btn:true, cur:pageObj.curPage === index}'
                    >{{index}}</span>
                </a>
                    
                <span v-bind:class='{hide: pageObj.curPage > pages - 4}'>...</span>
                <span v-bind:class='{btn:true, cur:pageObj.curPage === pages, hide:pages === 1}' @click='pageClick(pages)'>{{pages}}</span>
                <span v-bind:class='{btn:true, "not-clickable":pageObj.curPage === pages}' @click='nextClick'>&gt;</span>
                <span>前往 <input type="text" v-model="jumpPage" @keyup.enter="jumpClick"/> 页</span>
            </p>
        </div>
        <div :class='{"page": true, hide: !isMobile}'>
            <span v-bind:class='{btn:true, "not-clickable":pageObj.curPage === 1}' @click='preClick'>&lt; 上一页</span>
            <span v-bind:class='{btn:true, "not-clickable":pageObj.curPage === pages}' @click='nextClick'> 下一页&gt;</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pagination',
    props: { pageObj: Object },
    data() {
        return {
            jumpPage: '',
            isMobile: this.COMMON.isMobile,
        };
    },
    computed: {
        pages: function() {
            return this.pageObj.total ? Math.ceil(this.pageObj.total / this.pageObj.pagesize) : 1;
        }
    },
    methods: {
        pageClick(index) {
            this.pageObj.curPage = index;
        },
        preClick(){
            if (this.pageObj.curPage > 0) {
                this.pageObj.curPage--;
            }
        },
        nextClick(){
            if (this.pageObj.curPage < this.pages) {
                this.pageObj.curPage++;
            }
        },
        jumpClick(){
            if(parseInt(this.jumpPage, 10) <= this.pages){
                this.pageObj.curPage = parseInt(this.jumpPage, 10);
            }
        }
    },
};
</script>

<style lang="less">
.pagination {
    .page {
        text-align: right;
        margin: .2rem auto;
        .btn {
            display: inline-block;
            width: .3rem;
            overflow: hidden;
            line-height: 1.5em;
            vertical-align: middle;
            border-radius: .03rem;
            text-align: center;
            margin: 0 .05rem;
            cursor: pointer;
        }
        .cur {
            color: #fff;
            background: #0088eb;
        }
        .not-clickable {
            cursor: not-allowed;
            pointer-events: none;
        }
        .hide {
            display: none;
        }
        input {
            width: .3rem;
            border: 1px solid #ebedef;
            text-align: center;
        }
    }
    .hide {
        display: none;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .pagination {
        font-size: 12px
    }
}

@media screen and (max-width: 480px) {
    .pagination {
        .page {
            font-size: 12px;
            text-align: left;
            margin: .15rem .1rem;
            height: 0.3rem;
            .btn {
                width: 1rem;
                height: .3rem;
                background-color: #f6f6f6;
                line-height: .3rem;
                color: #666;
                border-radius: 0;
                &:last-child {
                    float: right;
                }
            }
            .not-clickable {
                cursor: not-allowed;
                display: none;
                pointer-events: none;
                background-color: #aaa;
                color: #fff;
            }
        }
    }
}
</style>